<template>
    <aside :class="{'side-closed':!isSidebarOpen}">
      <div class="side-nav-container">
        <div class="logo-container" :style="[!isSidebarOpen ? {width:'40px'} : '']">
          <img src="../assets/logo.png" alt="logo" srcset="">
          <span v-if="isSidebarOpen">TAP EGYPT</span>
        </div>
        <div v-if="isSidebarOpen" class="side-toggle-btn-container" @click="toggleSidebar">
          <font-awesome-icon icon="fa-solid fa-angles-left" />
        </div>
      </div>
      <nav class="sidebar-nav">
        <ul>
          <li
            v-for="(tab, index) in filteredTabs"
            :key="index"
            class="tab-item"
            @click="navigateTo(tab.route)"
            ><div >
              
              <div
              class="main-tab" :class="{'active-tap':isActiveRoute(tab.name)}" @click="toggleNestedList(index)"
                
              >
                <div class="tap-title">
                  <div class="title-icon">
                    <font-awesome-icon :icon="tab.icon" v-if="tab.icon" />
                  </div>  {{ tab.title }}
                </div>
                <div class="span tap-counter" v-if="isActiveRoute(tab.name)">
                  
                  <!-- i need here to add the total number of the tap and this number i need to be realtime updated from store of each module -->
                  <!-- {{ tab.total ?? 0  }} -->
                </div>
              </div>
              
            </div>
            <ul v-if="tab.nestedItems && isSidebarOpen" class="nasted-side-list" :class="{'active-list':isActive(index)}">
              <li v-for="(item, idx) in tab.nestedItems" :key="idx" class="nasted-option">
                {{ item }}
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <div class="nav-bottom-container">
        <ul class="nav-bottom-container-list active ">
          <li>
            <img src="../assets/user.png" width="30" height="30" alt="" srcset="">
          </li>
          <li v-if="store.getters['auth/getUserRole'] == 'Admin'" @click="toggleNotification">
            <font-awesome-icon icon="fa-solid fa-bell" :color="store.getters['sidebar/isNotificationOpen'] ?  '#00588b' : ''"/>
          </li>
        </ul>
        <el-drawer
                    v-model="isNotificationOpen"
                    :direction="'rtl'"
                    :modal-class="'add-notification-modal-drawer'"
                    :before-close="handleAddNotificationClose"
                >   
                <template #title>
                    <span><font-awesome-icon icon="fa-solid fa-bell" /> <span style="margin-left: 5px;">Add Notification</span></span>
                </template>
                    <!-- <PhoneInput /> -->
                    <el-form
                        ref="ruleFormRef"
                        :model="add_model"
                        :rules="rules"
                        label-width="auto"
                        class="demo-ruleForm"
                        :label-position="'top'"
                        :size="'default'"
                        status-icon
                    >
                                   
                        
                        <el-form-item label="Title">
                            <el-input
                                v-model="notification.title"
                                type="text"
                                placeholder="Title"
                                :disabled="isAddNotificationLoading"
                                clearable
                            />
                        </el-form-item>
                        <el-form-item label="Message">
                            <el-input
                                v-model="notification.description"
                                type="textarea"
                                maxlength="128"
                                placeholder="Notification message"
                                :disabled="isAddNotificationLoading"
                                clearable
                                :autosize="false"
                            />
                        </el-form-item>
                        <el-form-item label="Send To">
                            <el-select                    
                                v-model="notification.user_id" 
                                :disabled="isAddNotificationLoading"
                                placeholder="User"
                                filterable
                                
                                :reserve-keyword="false"
                            >
                            <!-- <el-option
                                v-for="member in lists.usersToAssign"
                                :key="member.id"
                                :label="member.first_name + ' ' +member.last_name"
                                :value="member.id"
                            /> -->
                            </el-select>
                        </el-form-item>
                        
                        
                    </el-form>
                    <template #footer>
                        <div style="flex: auto">
                            
                            <el-button  @click="handleAddNotificationClose">cancel</el-button>
                            <el-button type="primary" @click="handleAddSubmit"><font-awesome-icon icon="fa-solid fa-bell" color="#fff" /> <span style="margin-left: 5px;">Push Notification</span></el-button>
                            
                        </div>
                    </template>
        </el-drawer>
        <NotificationForm/>
      </div>
    </aside>
</template>

<script>
import { ref ,computed, reactive , watch } from 'vue';
import { useRoute , useRouter} from 'vue-router';
import { useStore } from 'vuex';
import NotificationForm from './notificationForm.vue';


export default {
  name: 'SideBar',
  components: {
    NotificationForm
  },
  setup(){
    const store = useStore(); 
    // الحالة لتتبع التبويبة المفتوحة
    const activeTab = ref(null);
    const route = useRoute(); // الحصول على المسار الحالي
    const router = useRouter();
    // Compute drawer visibility from the store
    const isNotificationOpen = computed(() => store.getters['sidebar/isNotificationOpen']);
    const notification = reactive({
      title:null,
      description:null,
      user_id:null,
      unit_id:null,
    });
    const isAddNotificationLoading = ref(false);
    
    const toggleNotification = () => {
      
      store.dispatch('notifications/toggleNotificationForm');
    };
    const handleAddNotificationClose = () => {
      toggleNotification();
    }
    
    // بيانات التبويبات
    // Tabs data
    const rules = reactive({
            client_name: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
    });
    const ruleFormRef = ref(null);
    const tabs = ref([
      {
        title: "CRM",
        icon: "sheet-plastic",
        route: "/profile",
        name:'profile',
        //nestedItems: ["Property Types", "Areas", "Levels", "Beds", "Baths"],
        allowedFor: ["Admin","Authorize","Sales"],
      },
      {
        title: "Inventory",
        icon: "fa-house",
        route: "/units",
        name:'units',
        total: 0,
      },
      {
        title: "Requests",
        icon: "hand-point-up",
        route: "/requests",
        name:'requests',
        //nestedItems: ["Fresh", "Cancelled"],
        allowedFor: ["Admin","Sales" ,"Authorize"],
      },
      {
        title: "Users",
        name:'users',
        icon: "fa-users",
        route: "/users",
        allowedFor: ["Admin","Authorize"],  // This tab should only be shown for "Admin"
      },
      
      {
        title: "Projects",
        route: "/projects",
        name:'projects',
        icon: "fa-compass-drafting",
        allowedFor: ["Admin","Authorize"],
      },
      {
        title: "Developers",
        route: "/developers",
        name:'developers',
        icon: "building-shield",
        allowedFor: ["Admin","Authorize"],
      },
      {
        title: "TodaysOffers",
        route: "/offers",
        name:'TodaysOffers',
        icon: "percent",
        allowedFor: ["Admin","Authorize"],
      },
      
      
      
    ]);

    // Filter tabs based on account type
    const filteredTabs = computed(() => {
      const accountType = store.getters['auth/getUserType'];  // Assuming the account type is stored in user state
      return tabs.value.filter(tab => {
        // Show the tab if there's no "allowedFor" or if the account_type matches
        return !tab.allowedFor || tab.allowedFor.includes(accountType);
      });
    });

    const toggleNestedList = (index) => {
      activeTab.value = activeTab.value === index ? null : index;
    };

    const isActiveRoute = (tabRoute) => {
      return route.name === tabRoute;
    };

    const navigateTo = (tabRoute) => {
      if (route.path !== tabRoute && tabRoute) {
        if (tabRoute == '/profile') {
          const userId = store.getters['auth/getUserId'];
          router.push(`${tabRoute}/${userId}`);
        } else {
          router.push(tabRoute);
        }
      }
    };

    const isActive = (index) => activeTab.value === index;

    const toggleSidebar = () => {
      store.dispatch('sidebar/toggleSidebar');
    };
    

    const isSidebarOpen = computed(() => store.getters['sidebar/isSidebarOpen']);
    
    
    return {
      rules,
      ruleFormRef,
      notification,
      isNotificationOpen,
      isAddNotificationLoading,
      toggleNotification,
      handleAddNotificationClose,
      tabs,
      activeTab,
      toggleNestedList,
      isActiveRoute,
      isActive,
      navigateTo,
      toggleSidebar,
      filteredTabs,
      isSidebarOpen,
      store
    };
  }
}
</script>
<style>
@media screen and (max-width: 768px) {
  aside {
    width: 0px ;
    padding-left: 1rem !important ;
    position: fixed;
    background-color: #eeeeee;
    height: calc(100vh - 72px);
    margin-top: 50px; /* Hide sidebar on smaller screens */
  }
  .side-closed{
    width: 0px !important;
    padding: 0rem !important;
    transition: 0.3s ease-in-out;
  }
}


.side-toggle-btn-container{
  color: #999999;
  cursor: pointer;
}
.logo svg{ 
  cursor: pointer;
}
/*Side Nave Style (Logo and Toggle btn)*/
.side-nav-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    width: 100%;
  
}
.side-nav-container .logo-container{
  display: flex;
  gap: 12px;
  max-height: 35px;
  overflow: hidden;
  align-items: center;
  transition: 0.3s ease-in-out;
}
.side-nav-container .logo-container span {
  line-height: 50px;
  font-weight: bold;
}
.side-nav-container img{
  width: 35px;
  height: 35px;
  margin: auto;
} 
/* Sidebar */
aside {
  width: 170px; /* Adjust width as needed */
  padding: 0rem 1rem 0px 0px;
  transition: 0.3s ease-in-out;
  overflow: hidden;
  height: calc(100vh - 2rem);
  position: relative;
  box-sizing: content-box;
}
.nav-bottom-container{
  position: absolute;
  bottom: 0px;
  width: 35px;
}
.nav-bottom-container-list li{
  cursor: pointer;
  color: #999999;
  transition: 0.3s ease;
}
.nav-bottom-container-list li:hover{
  color: #000;
}
.nav-bottom-container  .active{
    display: flex;
    flex-direction: column-reverse;
    gap: 15px;
    align-items: center;
    list-style: none;
    transition: 0.3s ease;
    padding: 0px;
}
.sidebar-nav ul {
  list-style: none;
  padding: 0 ;
  display: block;
  transition: 0.5s ease;
}

.sidebar-nav li {
  margin-bottom: 0.3rem;
  display: block;
  cursor: pointer;
  overflow: hidden;
  line-height: 30px;
}

.sidebar-nav .main-tab {
  text-decoration: none;
  color: #585858;
  padding: 0px 0.6rem;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
}
.main-tab .tap-counter{
  font-size: 14px;
}
.main-tab .tap-title{
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  transition: 0.2s ease;
}
.main-tab svg{
  font-size: 14px;
}
.sidebar-nav .main-tab:hover {
  border-radius: 10px;
  color: #055866;
  font-weight: 500;
  transition: 0.3s ease;
}
.main-tab:hover .title-icon{
  color: #055866;
  transition: 0.3s ease;
}
/*Side Nave Style (Logo and Toggle btn)*/
.side-nav-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
  
}
.side-nav-container .logo-container span {
  line-height: 50px;
  font-weight: bold;
}



.title-icon{
    width: 20px;
    color: #999999;
    text-align: left;
    display: flex;
    transition: 0.3s ease;
}

.nasted-side-list{
  overflow: hidden;
  padding-left: 40px !important;
  max-height: 0px;
  font-size: 14px;
  transition: 0.5s ease ;
  
}
.active-list{
  max-height: 500px ;
  margin-top: 5px;
  transition: 0.5s ease ;
}
.active-tap{
  background-color: #fff;
  color: #055866 !important;
  border-radius: 10px !important;
  font-weight: 600;
  border: solid 1px #DDD;
  box-shadow: 0px 0px 3px -2px #000;
}
.active-tap .title-icon{
  color: #055866;
}
.side-closed{
  width: 37px;
  padding: 1rem 0.7rem 0.5rem 0.7rem;
  transition: 0.3s ease-in-out;
  height: calc(100vh - 4rem);
}
</style>